exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AKBXDolUEkjgZ8t9YVtQ0{width:100%;height:100%}", ""]);

// exports
exports.locals = {
	"uiLessContainer": "AKBXDolUEkjgZ8t9YVtQ0"
};